import Api from "@/services/api";
import {
	LOAD_TRANSACTIONS,
	REMOVE_TRANSACTION,
	REMOVE_TRANSACTIONS,
	ADD_ALERT,
} from "@/store/_actiontypes";
import { DELETE_TRANSACTION, SET_TRANSACTION } from "@/store/_mutationtypes";

const state = {
	transactionlist: [],
};

const actions = {
	[LOAD_TRANSACTIONS]({ commit }) {
		Api.get("/transaction").then((response) => {
			let value = response.data;
			commit(SET_TRANSACTION, value);
		});
	},
	[REMOVE_TRANSACTION]({ commit, dispatch }, { id }) {
		Api.delete(`/transaction/${id}`).then(() => {
			commit(DELETE_TRANSACTION, id);
			dispatch(
				`alert/${ADD_ALERT}`,
				{ message: "Transaction deleted successfully", color: "success" },
				{ root: true }
			);
		});
	},
	[REMOVE_TRANSACTIONS]({ commit, dispatch }, { ids }) {
		let deletedCount = 0;

		const updateProgress = () => {
			dispatch(
				`alert/${ADD_ALERT}`,
				{
					message: `Deleting ${deletedCount}/${ids.length} transactions...`,
					color: "info",
				},
				{ root: true }
			);
		};

		const deletedTransactions = ids.map((id) => {
			return Api.delete(`/transaction/${id}`).then(() => {
				commit(DELETE_TRANSACTION, id);
				deletedCount++;
				updateProgress();
			});
		});

		Promise.all(deletedTransactions)
			.then(() => {
				dispatch(
					`alert/${ADD_ALERT}`,
					{
						message: `Successfully deleted ${ids.length} transactions`,
						color: "success",
					},
					{ root: true }
				);
			})
			.catch((error) => {
				console.error("Error deleting transactions:", error);
			});
	},
};
const mutations = {
	[SET_TRANSACTION](state, value) {
		state.transactionlist = value;
	},
	[DELETE_TRANSACTION](state, id) {
		state.transactionlist = state.transactionlist.filter((h) => h.id != id);
	},
};

export const transactions = {
	namespaced: true,
	state,
	actions,
	mutations,
};
